import {
  NoResultsSearchImage,
  GroupsAllAddedImage,
  GroupdetailsAppsEmptyImage,
  GroupdetailsProjectsEmptyImage,
  GroupdetailsMapLayersEmptyImage,
  GroupdetailsMembersEmptyImage,
} from '../images';

const noResultsForSearch = {
  Image: NoResultsSearchImage,
  heading: 'No results',
  description: 'Try another search.',
};

export default function addResourcesFallbackUIProps({
  resource,
  isAllAdded = false,
  zeroResourcesInOrg = false,
  isSearching = false,
  zeroResults = false,
  imageWidth = '204px',
  imageHeight = '100%',
}) {
  const imageProps = { imageWidth, imageHeight };
  if (isSearching && zeroResults) {
    return {
      ...imageProps,
      ...noResultsForSearch,
    };
  }
  if (isAllAdded) {
    return {
      ...imageProps,
      Image: GroupsAllAddedImage,
      heading: "You're all set!",
      description: 'Everything is already in the Group.',
    };
  }
  if (zeroResourcesInOrg) {
    switch (resource) {
      case 'apps':
        return {
          ...imageProps,
          Image: GroupdetailsAppsEmptyImage,
          heading: 'No Apps',
          description: 'Create an App to add it to the Group.',
        };
      case 'layers':
        return {
          ...imageProps,
          Image: GroupdetailsMapLayersEmptyImage,
          heading: 'No Map Layers',
          description: 'Create a Map Layer to add it to the Group.',
        };
      case 'projects':
        return {
          ...imageProps,
          Image: GroupdetailsProjectsEmptyImage,
          heading: 'No Projects',
          description: 'Create a Project to add it to the Group.',
        };
      default:
        return undefined;
    }
  }
  return undefined;
}

export function listResourcesFallbackUIProps({
  resource,
  isSearching,
}) {
  if (isSearching) {
    return {
      EmptyImage: noResultsForSearch.Image,
      emptyText: noResultsForSearch.heading,
      emptyTextHelper: noResultsForSearch.description,
    };
  }

  switch (resource) {
    case 'apps':
      return {
        EmptyImage: GroupdetailsAppsEmptyImage,
        emptyText: 'Your group has no apps',
        emptyTextHelper: 'Add apps to manage their access.',
      };
    case 'layers':
      return {
        EmptyImage: GroupdetailsMapLayersEmptyImage,
        emptyText: 'Your group has no map layers',
        emptyTextHelper: 'Add map layers to manage their access.',
      };
    case 'projects':
      return {
        EmptyImage: GroupdetailsProjectsEmptyImage,
        emptyText: 'Your group has no projects',
        emptyTextHelper: 'Add projects to manage their access.',
      };
    case 'members':
      return {
        EmptyImage: GroupdetailsMembersEmptyImage,
        emptyText: 'Your group has no members',
        emptyTextHelper: 'Add members to manage their access.',
      };
    default:
      return {
        EmptyImage: GroupdetailsAppsEmptyImage,
        emptyText: 'Nothing found.',
        emptyTextHelper: '',
      };
  }
}
